"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./SearchBar.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SearchBarMethods = _interopRequireWildcard(require("./SearchBarMethods"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SearchBar = _ref => {
  let {
    searchItems,
    handleSubmit,
    name,
    placeholder,
    predictiveSearch
  } = _ref;
  const [input, setInput] = (0, _react.useState)("");
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: e => (0, _SearchBarMethods.processSubmission)(e, input, handleSubmit, name),
    className: "ter-search-bar"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    value: input,
    onChange: e => setInput(e.target.value),
    placeholder: placeholder || "Search",
    className: "ter-search-bar__input"
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "ter-search-bar__submit"
  }, "Submit"), predictiveSearch && input?.length > 0 && searchItems?.length > 0 && (0, _SearchBarMethods.default)(searchItems, input)?.length > 0 && /*#__PURE__*/_react.default.createElement("ul", {
    className: "ter-search-bar__predicted-list"
  }, (0, _SearchBarMethods.default)(searchItems, input, setInput)));
};
var _default = SearchBar;
exports.default = _default;
SearchBar.propTypes = {
  searchItems: _propTypes.default.arrayOf(_propTypes.default.string.isRequired),
  handleSubmit: _propTypes.default.func.isRequired,
  placeholder: _propTypes.default.string,
  predictiveSearch: _propTypes.default.bool,
  name: _propTypes.default.string
};